import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const TradesBlotterRouteLazy = lazyWithRetry(() => import('./page'));
export function TradesBlotterRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <TradesBlotterRouteLazy />
    </Suspense>
  );
}
